(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBOfficeDeleteController',OfficeDeleteController);

    OfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Office'];

    function OfficeDeleteController($uibModalInstance, entity, Office) {
        var vm = this;

        vm.office = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, officeName) {
            Office.delete({id: id, officeName: officeName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
